module.exports = __webpack_public_path__ + "media/components/country-flag/static/lt-a4c7974b0348d31372e3fa6b5122083b.svg";